// null OR 空欄の置き換え関数
// 引数val1がnullまたは空欄の場合に引数val2を返す
function nvl(val1,val2){
  // if(!val1){
if((val1 == null) || (val1 == "")){
    return val2
  }else{
    return val1
  }
}

// disabled
//セレクタから検索
// attribute1:ID属性名,attribute2：Class属性名,disabledChange:
function disabled_Get(attribute1,attribute2,disabledChange){
  // 範囲指定のかわり
  // const wrap = document.querySelector(attribute1);
  // const items = wrap.querySelectorAll(attribute2)
  const wrap = document.getElementById(attribute1);
  const items = wrap.getElementsByClassName(attribute2)

  disabled(items,disabledChange)
}
// 複雑？
function disabled(items,disabledChange){
  for (var i = 0; i < items.length; i++) {
    if(disabledChange){
      items[i].disabled = disabledChange;
    }else{
      if(disabledChange !== undefined){
        items[i].disabled = disabledChange;
      }else{
        items[i].disabled = !items[i].disabled;
      }
    }

  }
}

export default { nvl,disabled_Get,disabled };
